import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import PortInLocationFormA from './port-in-location-form.component';
import PortInSubscriptionFormA from './port-in-subscription-form.component';
import PortInBusinessFormA from './port-in-business-form.component';
import { wirelessPortInActions } from "./../../../../../../store/external/request-reducer/order-request-reducer/wireless-request/wireless-port-in.reducer";
import { createRequestActions } from "./../../../../../../store/external/request-reducer/create-request.reducer";
import Translation from '../../../../../common/translation/translation.component';
import { TRANSLATIONS as translation } from '../../../../../../utils/constant.utils';
import { Milestone } from '../../../../../common/milestone/milestone.component';
import { Loading } from '../../../../../common/loading/index';
import { withRouter } from 'react-router-dom';

class PortInSubscription extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLocationForm: true,
            isSubscriptionForm: false,
            isBusinessForm: false,
            activeIndex:0,
            milestones: [
                "location",
                "subscription",
                "business_justification"
            ]
        }
    }

    componentWillMount() {
        const orderId = this.props.match.params.orderId;
        this.props.getNewPortInFormData(orderId);
    }

    componentWillUnmount() {
        this.props.resetWirelessPortInForm();
        
        //this.props.resetRequestData();
    }

    nextAction = () => {

        const { isLocationForm, isSubscriptionForm } = this.state;
        const { disableROBCheckbox } = this.props;

        if (isSubscriptionForm) {
            this.setState({
                isLocationForm: false,
                isSubscriptionForm: false,
                isBusinessForm: true,
                activeIndex: 2   
            });
        }
        else if (isLocationForm) {
            this.setState({
                isLocationForm: false,
                isSubscriptionForm: true,
                isBusinessForm: false,
                activeIndex: 1
            });

            disableROBCheckbox(true);
        }
    }

    prevAction = () => {

        const { isSubscriptionForm, isBusinessForm } = this.state;
        const { disableROBCheckbox } = this.props;

        if (isBusinessForm) {
            this.setState({
                isLocationForm: false,
                isSubscriptionForm: true,
                isBusinessForm: false,
                activeIndex: 1
            });
        }
        else if (isSubscriptionForm) {
            this.setState({
                isLocationForm: true,
                isSubscriptionForm: false,
                isBusinessForm: false,
                activeIndex: 0
            });

            if(this.props.wirelessPortInLocationFormA.locationId !== -1){
                this.props.disableAutoScroll(true);
            } else{
                this.props.disableAutoScroll(false);
            } 
           
            disableROBCheckbox(false);
        }

    }

    onClickCancel = () => {
        const { modalClose } = this.props;

        if (modalClose !== null && modalClose !== undefined) {
            modalClose();
        }
    }

    displayForm = () => {
        const { isLocationForm, isSubscriptionForm } = this.state;
        const { modalMessage, closeAction } = this.props;
        let form;

        if (isLocationForm) {
            form = <PortInLocationFormA disableAutoScroll={this.props.disableAutoScroll} onClickCancel={this.onClickCancel} nextAction={this.nextAction} />
        } else if (isSubscriptionForm) {
            form = <PortInSubscriptionFormA onClickCancel={this.onClickCancel} nextAction={this.nextAction} prevAction={this.prevAction} />
        } else {
            form = <PortInBusinessFormA hideRequestModal={this.props.hideRequestModal} closeAction={closeAction} onClickCancel={this.onClickCancel} prevAction={this.prevAction} modalMessage={modalMessage} />
        }

        return (form);
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '')
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }

    render() {
        const { wirelessPortInRequest } = this.props;
        return (
            <div>
                <Row>
                    <Col xs={12} md={12} lg={12}>
                        <h6 className="plan-detail-sub-header"><Translation translationKey="order_request_details" /></h6>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={12} lg={12}>
                        <Milestone milestones={this.state.milestones} activeIndex={this.state.activeIndex}/>
                    </Col>
                </Row>
                {
                    wirelessPortInRequest.isLoading ?
                        <>
                            <Loading />
                        </> :
                        this.displayForm()
                }
            </div>
        );
    }
};

export default withRouter(
    connect(
        state => {
            const { createRequest, wirelessPortInRequest, translation } = state;
            const { wirelessPortInLocationFormA } = state.form;
            return {
                createRequest
                , wirelessPortInRequest
                , wirelessPortInLocationFormA
                , ...translation
            };
        }
        , dispatch =>
            bindActionCreators(
                Object.assign({}, wirelessPortInActions
                    , createRequestActions),
                dispatch
            )
    )(PortInSubscription)
);